export class DatosEmpresa {
    public estado: number;
    public nombre: string;
    public nroEmpresa: string;
    public nroInternoEmpresa: number;
    public nroContribuyente: string;
    public nroInteContribuyente: number;
    public nroObra: string;
    // TODO: REVISAR SI ATRIBUTO APORTACIONES ES NECESARIO (TAL VEZ POR CAROUSEL)
    public aportaciones: number[];
    public codigoAportacion: number;
    public descripcionAportacion: string;
    public emailOperativo: string;
    public tienePermisos: boolean;
}